package one.healthium.db.dao

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Deferred
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flow
import one.healthium.base.coroutines.IO
import one.healthium.db.AppDatabase
import one.healthium.db.ShoppingListDataEntity

class ShoppingListDataDao(
    private val db: Deferred<AppDatabase>
) {
    fun getShoppingListData(id: String): Flow<List<ShoppingListDataEntity>> {
        return flow { emit(db.await()) }
            .flatMapLatest { it.shoppingListDataQueries.selectShoppingListData(id).asFlow() }
            .mapToList(Dispatchers.IO)
    }

    suspend fun setShoppingListChecked(id: String, itemId: String, checked: Boolean) {
        db.await().shoppingListDataQueries.insertData(
            ShoppingListDataEntity(
                id = "$id-$itemId",
                checked = if (checked) 1L else 0L,
                listId = id,
                itemId = itemId,
            )
        )
    }
}